export const getRandomInt = (max: number) =>
  Math.floor(Math.random() * Math.floor(max));
